import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.css']
})
export class StepsComponent implements OnInit {
  @Input() steps:any = {};
  @Input() showSuccessMessage: boolean;
  constructor() {
    
  }

  ngOnInit(): void {
  }

}
